const Vue = require("vue");
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

Vue.config.productionTip = false;

import "./lib/i18n";

//this.$utils
const XEUtils = require("xe-utils");
import VXEUtils from "vxe-utils";
Vue.use(VXEUtils, XEUtils);

// import VueLazyload from "vue-lazyload";
// Vue.use(VueLazyload, {
//   // set observer to true
//   observer: true,

//   // optional
//   observerOptions: {
//     rootMargin: "0px",
//     threshold: 0.1
//   }
// });

import { VLazyImagePlugin } from "v-lazy-image";
Vue.use(VLazyImagePlugin);

// import VueAnimate from "vue-animate-plugin";

// Vue.use(VueAnimate, {
//   valueof: ":", // 表示v-animate指令修饰符中键与值使用什么字符分割，默认使用':'
//   begin: "begin", // 表示v-animate指令修饰符中动画开始之前的挂钩点的名称，可以通过方式`.begin:onBegin`注入钩子函数，它可以是async function
//   after: "complete", // 表示v-animate指令修饰符中动画结束之后的挂钩点的名称，`.complete:onComplete`方式注入钩子，它可以是async function
//   callback: null // 表示v-animate指令中，动画部分（包括之后的衔接部分）完全执行完毕后的钩子函数注入口
// });

const axios = require("axios");
Vue.prototype.$axios = axios;

import "../src/assets/icon/iconfont.css";
import "../src/assets/icon/iconfont.js";

import IInputBox from "@/components/i-input-box.vue";
Vue.component("IInputBox", IInputBox);

Vue.prototype.$bus = new Vue(); //注册总线

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  render: (h: any) => h(App)
});
